import { Routes } from '@angular/router';
import { PageErrorsComponent } from './page-errors/page-errors.component';
import { PagePermissionComponent } from './page-permission/page-permission.component';
import { PageDeletedComponent } from './page-deleted/page-deleted.component';
import { ErrorsSeo404Params, ErrorsSeoPermissionParams, ErrorsSeoDeletedParams } from '@app/modules/errors-modules/errors.seo';
import { RoutingConfig } from '@app/routing/routing.config';

export const ErrorsRoutes: Routes = [
  { 
    path: RoutingConfig.Page404,
    component: PageErrorsComponent,
    data: {
      SEO: ErrorsSeo404Params
    }
  },
  {
    path: RoutingConfig.PagePermission,
    component: PagePermissionComponent,
    data: {
      SEO: ErrorsSeoPermissionParams
    }
  },
  {
    path: RoutingConfig.PageDeleted,
    component: PageDeletedComponent,
    data: {
      SEO: ErrorsSeoDeletedParams
    }
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];
